import React, { useState } from 'react';
import { Card, Button, Form } from 'react-bootstrap';

const ProjectForm = ({ onCreate, organizations, fetchOrgs }) => {
  const [formData, setFormData] = useState({
    name: '',
    organizationId: '',
    description: ''
  });

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    const success = await onCreate(formData);
    if (success) {
      setFormData({ name: '', organizationId: '', description: '' });
    }
  };

  return (
    <Card className="mb-4 shadow-sm border-0">
      <Card.Body>
        <Card.Title className="h5 mb-3 text-muted small text-uppercase font-weight-bold">Create New Company</Card.Title>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label className="small font-weight-bold">Organization</Form.Label>
            <Form.Control 
              as="select" 
              name="organizationId" 
              value={formData.organizationId} 
              onChange={onChange} 
              size="sm"
              required
            >
              <option value="">-- Select Parent Organization --</option>
              {organizations?.map(o => <option key={o._id} value={o._id}>{o.name}</option>)}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label className="small font-weight-bold">Company Name</Form.Label>
            <Form.Control 
              type="text" 
              name="name" 
              value={formData.name} 
              onChange={onChange} 
              size="sm"
              required 
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="small font-weight-bold">Description</Form.Label>
            <Form.Control 
              as="textarea" 
              name="description" 
              value={formData.description} 
              onChange={onChange} 
              size="sm"
              rows={3}
            />
          </Form.Group>
          <Button type="submit" variant="primary" size="sm" block>
            Create Company
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ProjectForm;
